import { render, staticRenderFns } from "./Annoncement.vue?vue&type=template&id=64564e86&scoped=true&"
import script from "./Annoncement.vue?vue&type=script&lang=ts&"
export * from "./Annoncement.vue?vue&type=script&lang=ts&"
import style0 from "./Annoncement.vue?vue&type=style&index=0&id=64564e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64564e86",
  null
  
)

export default component.exports